export const ComponentsIdEnum = {
  BasicInfoPage: 'BasicInfoPage',
  ConfirmationPage: 'ConfirmationPage',
  
  NewBornMedicals_YourJourneyPage: 'NewBornMedicals_YourJourneyPage',
  NewBornMedicals_JourneySpecificsPage: 'NewBornMedicals_JourneySpecificsPage',
  NewBornMedicals_PlansPage: 'NewBornMedicals_PlansPage',

  USChildFilings_ChildInfoPage: 'USChildFilings_ChildInfoPage',
  USChildFilings_TimelinePage: 'USChildFilings_TimelinePage',
  USChildFilings_PlansPage: 'USChildFilings_PlansPage',
  
  FamilyTaxAudit_ParentInfoPage: 'FamilyTaxAudit_ParentInfoPage',
  FamilyTaxAudit_FamilyInfoPage: 'FamilyTaxAudit_FamilyInfoPage',
  FamilyTaxAudit_PlansPage: 'FamilyTaxAudit_PlansPage',
  
  ParentVisas_ParentInfoPage: 'ParentVisas_ParentInfoPage',
  ParentVisas_VisaInfoPage: 'ParentVisas_VisaInfoPage',
  ParentVisas_PlansPage: 'ParentVisas_PlansPage',
  
  USChildPassports_ChildInfoPage: 'USChildPassports_ChildInfoPage',
  USChildPassports_TimelinePage: 'USChildPassports_TimelinePage',
  USChildPassports_PlansPage: 'USChildPassports_PlansPage',
  
  ChildTravelDocs_ChildInfoPage: 'ChildTravelDocs_ChildInfoPage',
  ChildTravelDocs_TimelinePage: 'ChildTravelDocs_TimelinePage',
  ChildTravelDocs_PlansPage: 'ChildTravelDocs_PlansPage',
  
  USBirthCertificates_ChildInfoPage: 'USBirthCertificates_ChildInfoPage',
  USBirthCertificates_TimelinePage: 'USBirthCertificates_TimelinePage',
  USBirthCertificates_PlansPage: 'USBirthCertificates_PlansPage',

  USSocialSecurityNumber_ChildInfoPage: 'USSocialSecurityNumber_ChildInfoPage',
  USSocialSecurityNumber_TimelinePage: 'USSocialSecurityNumber_TimelinePage',
  USSocialSecurityNumber_PlansPage: 'USSocialSecurityNumber_PlansPage',

  MedicalBilling_BackgroundInfoPage: 'MedicalBilling_BackgroundInfoPage',

  ServicesPage: 'ServicesPage',
}

export const CategoryEnum = {
  NEWBORN_MEDICAL: 'NEWBORN_MEDICAL',
  US_CHILD_FILINGS: 'US_CHILD_FILINGS',
  FAMILY_TAX_AUDIT: 'FAMILY_TAX_AUDIT',
  PARENT_VISAS: 'PARENT_VISAS',
  US_CHILD_PASSPORTS: 'US_CHILD_PASSPORTS',
  CHILD_TRAVEL_DOCS: 'CHILD_TRAVEL_DOCS',
  US_BIRTH_CERTIFICATES: 'US_BIRTH_CERTIFICATES',
  US_SOCIAL_SECURITY_NUMBERS: 'US_SOCIAL_SECURITY_NUMBERS',
  MEDICAL_BILLING: 'MEDICAL_BILLING',
  SERVICES: 'SERVICES',
}

export const PlanEnum = {
  CHILD_TRAVEL_DOCS_DIY_CLIENT: 'CHILD_TRAVEL_DOCS_DIY_CLIENT',
  CHILD_TRAVEL_DOCS_DIY_NON_CLIENT: 'CHILD_TRAVEL_DOCS_DIY_NON_CLIENT',
  CHILD_TRAVEL_DOCS_MANAGED_CLIENT: 'CHILD_TRAVEL_DOCS_MANAGED_CLIENT',
  CHILD_TRAVEL_DOCS_MANAGED_NON_CLIENT: 'CHILD_TRAVEL_DOCS_MANAGED_NON_CLIENT',
  FAMILY_TAX_AUDIT_DIY_CLIENT: 'FAMILY_TAX_AUDIT_DIY_CLIENT',
  FAMILY_TAX_AUDIT_DIY_NON_CLIENT: 'FAMILY_TAX_AUDIT_DIY_NON_CLIENT',
  FAMILY_TAX_AUDIT_MANAGED_CLIENT: 'FAMILY_TAX_AUDIT_MANAGED_CLIENT',
  FAMILY_TAX_AUDIT_MANAGED_NON_CLIENT: 'FAMILY_TAX_AUDIT_MANAGED_NON_CLIENT',
  NEWBORN_MEDICAL_PER_JOURNEY: 'NEWBORN_MEDICAL_PER_JOURNEY',
  NEWBORN_MEDICAL_PER_YEAR: 'NEWBORN_MEDICAL_PER_YEAR',
  PARENT_VISAS_MANAGED_CLIENT: 'PARENT_VISAS_MANAGED_CLIENT',
  PARENT_VISAS_MANAGED_NON_CLIENT: 'PARENT_VISAS_MANAGED_NON_CLIENT',
  US_BIRTH_CERTIFICATES_DIY_CLIENT: 'US_BIRTH_CERTIFICATES_DIY_CLIENT',
  US_BIRTH_CERTIFICATES_DIY_NON_CLIENT: 'US_BIRTH_CERTIFICATES_DIY_NON_CLIENT',
  US_BIRTH_CERTIFICATES_MANAGED_CLIENT: 'US_BIRTH_CERTIFICATES_MANAGED_CLIENT',
  US_BIRTH_CERTIFICATES_MANAGED_NON_CLIENT: 'US_BIRTH_CERTIFICATES_MANAGED_NON_CLIENT',
  US_CHILD_FILINGS_DIY_CLIENT: 'US_CHILD_FILINGS_DIY_CLIENT',
  US_CHILD_FILINGS_DIY_NON_CLIENT: 'US_CHILD_FILINGS_DIY_NON_CLIENT',
  US_CHILD_FILINGS_MANAGED_CLIENT: 'US_CHILD_FILINGS_MANAGED_CLIENT',
  US_CHILD_FILINGS_MANAGED_NON_CLIENT: 'US_CHILD_FILINGS_MANAGED_NON_CLIENT',
  US_CHILD_PASSPORTS_DIY_CLIENT: 'US_CHILD_PASSPORTS_DIY_CLIENT',
  US_CHILD_PASSPORTS_DIY_NON_CLIENT: 'US_CHILD_PASSPORTS_DIY_NON_CLIENT',
  US_CHILD_PASSPORTS_MANAGED_CLIENT: 'US_CHILD_PASSPORTS_MANAGED_CLIENT',
  US_CHILD_PASSPORTS_MANAGED_NON_CLIENT: 'US_CHILD_PASSPORTS_MANAGED_NON_CLIENT',

  US_SOCIAL_SECURITY_NUMBERS_DIY_CLIENT: 'US_SOCIAL_SECURITY_NUMBERS_DIY_CLIENT',
  US_SOCIAL_SECURITY_NUMBERS_DIY_NON_CLIENT: 'US_SOCIAL_SECURITY_NUMBERS_DIY_NON_CLIENT',
  US_SOCIAL_SECURITY_NUMBERS_MANAGED_CLIENT: 'US_SOCIAL_SECURITY_NUMBERS_MANAGED_CLIENT',
  US_SOCIAL_SECURITY_NUMBERS_MANAGED_NON_CLIENT: 'US_SOCIAL_SECURITY_NUMBERS_MANAGED_NON_CLIENT',

  MEDICAL_BILLING_MANAGED_CLIENT: 'MEDICAL_BILLING_MANAGED_CLIENT',
  MEDICAL_BILLING_MANAGED_NON_CLIENT: 'MEDICAL_BILLING_MANAGED_NON_CLIENT',
}

export const SurrogacyStageEnum = {
  BEFORE_TRANSFER: 'BEFORE_TRANSFER',
  WITHIN_12_WEEKS: 'WITHIN_12_WEEKS',
  BETWEEN_12_15_WEEKS: 'BETWEEN_12_15_WEEKS',
  BETWEEN_15_25_WEEKS: 'BETWEEN_15_25_WEEKS',
  AFTER_25: 'AFTER_25',
  AFTER_BIRTH: 'AFTER_BIRTH',
}

export const EmbryoSourceEnum = {
  PARENT_1: 'PARENT_1',
  PARENT_2: 'PARENT_2',
  DONOR_SURROGATE: 'DONOR_SURROGATE',
  DONOR_OTHER: 'DONOR_OTHER',
  DONOR: 'DONOR',
}

export const EmbryoSplitTypeEnum = {
  DICHORIONIC_DIAMNIOTIC: 'DICHORIONIC_DIAMNIOTIC',
  MONOCHORIONIC_DIAMNIOTIC: 'MONOCHORIONIC_DIAMNIOTIC',
  MONOCHORIONIC_MONOAMNIOTIC: 'MONOCHORIONIC_MONOAMNIOTIC',
}

export const RoleEnum = {
  EMPLOYEE: 'EMPLOYEE',
  OWNER: 'OWNER',
  BOTH: 'BOTH',
}

export const CertificateTypeEnum = {
  CERTIFIED_COPY: 'CERTIFIED_COPY',
  APOSTILLE: 'APOSTILLE',
}